export const getIconUrl = _ref => {
  let {
    origin,
    appKey,
    appIconLink
  } = _ref;
  if (origin === 'token') return null;
  return appIconLink.expand({
    appKey
  });
};
export const getFallbackIconUrl = (origin, icon) => origin === 'token' ? null : icon;
export const getIconType = origin => origin === 'token' ? 'key' : 'app';